'use strict';

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TipHandler = exports.MessageHandler = exports.default = undefined;

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Handler = function () {
  function Handler(manager, config) {
    _classCallCheck(this, Handler);

    this.manager = manager;
    this.config = config;
    this.id = config.id;
  }

  Handler.prototype.getConfig = function getConfig() {
    return this.config;
  };

  Handler.prototype.getType = function getType() {
    return this.config.type;
  };

  // @deprecated


  Handler.prototype.isModel = function isModel() {
    return this.isModal();
  };

  Handler.prototype.isModal = function isModal() {
    return this.config.modal;
  };

  Handler.prototype.getId = function getId() {
    return this.config.id;
  };

  Handler.prototype.close = function close() {
    this.manager.removeItem(this.getId());
  };

  return Handler;
}();

exports.default = Handler;


function findTip(target) {
  if (!target) return null;
  // optimize deep finding on mouseover
  var deepLimit = 10;
  while (target && deepLimit-- > 0) {
    // get tip from target node
    if (target.dataset && target.dataset.tip) {
      return {
        content: target.dataset.tip,
        position: target.dataset.position || target.dataset.direction || target.dataset.dir,
        theme: target.dataset.theme,
        target: target
      };
    }

    // or get tip from child nodes
    var children = target.childNodes;
    var l = children.length;
    var child = void 0;

    while (l-- > 0) {
      child = children[l];
      if (child.dataset && child.dataset.role === 'tip') {
        var html = child.innerHTML;
        if (!html) {
          return null;
        }
        return {
          content: html,
          position: child.dataset.position,
          theme: child.dataset.theme,
          target: target
        };
      }
    }

    target = target.parentNode;
  }

  return null;
}

var MessageHandler = exports.MessageHandler = function (_Handler) {
  _inherits(MessageHandler, _Handler);

  function MessageHandler() {
    _classCallCheck(this, MessageHandler);

    return _possibleConstructorReturn(this, _Handler.apply(this, arguments));
  }

  MessageHandler.prototype.isModal = function isModal() {
    return false;
  };

  return MessageHandler;
}(Handler);

var TipHandler = exports.TipHandler = function (_Handler2) {
  _inherits(TipHandler, _Handler2);

  function TipHandler(manager) {
    _classCallCheck(this, TipHandler);

    var _this2 = _possibleConstructorReturn(this, _Handler2.call(this, manager, {
      id: 1400,
      type: 'tip'
    }));

    _this2.tip = null;
    _this2.emitter = new _events2.default();
    return _this2;
  }

  TipHandler.prototype.getTip = function getTip() {
    return this.tip;
  };

  TipHandler.prototype.isModal = function isModal() {
    return false;
  };

  TipHandler.prototype.setTarget = function setTarget(target) {
    var _this3 = this;

    var tip = findTip(target);
    if (tip) {
      if (this.tip) {
        // the some target should return
        if (this.tip.target === tip.target) {
          this.tip = tip;
          return;
        }
        // not show already, reset show delay
        if (this.showDelay) {
          clearTimeout(this.showDelay);
          this.showDelay = null;
          this.tip = null;
        } else {
          if (this.hideDelay) {
            clearTimeout(this.hideDelay);
            this.hideDelay = null;
          }
          this.tip = tip;
          this.emitter.emit('tipchange');
          return;
        }
      }

      this.tip = tip;
      if (this.hideDelay) {
        clearTimeout(this.hideDelay);
        this.hideDelay = null;
        this.emitter.emit('tipchange');
      } else {
        this.showDelay = setTimeout(function () {
          _this3.showDelay = null;
          _this3.emitter.emit('tipchange');
        }, 350);
      }
    } else {
      if (this.showDelay) {
        clearTimeout(this.showDelay);
        this.showDelay = null;
      } else {
        this.hideDelay = setTimeout(function () {
          _this3.hideDelay = null;
        }, 100);
      }
      this.tip = null;

      this.emitter.emit('tipchange');
    }
  };

  TipHandler.prototype.hideImmediately = function hideImmediately() {
    if (this.hideDelay) {
      clearTimeout(this.hideDelay);
      this.hideDelay = null;
    }
    if (this.showDelay) {
      clearTimeout(this.showDelay);
      this.showDelay = null;
    }
    this.tip = null;
    this.emitter.emit('tipchange');
  };

  TipHandler.prototype.close = function close() {
    return;
  };

  TipHandler.prototype.onTipChange = function onTipChange(func) {
    var _this4 = this;

    this.emitter.on('tipchange', func);
    return function () {
      _this4.emitter.removeListener('tipchange', func);
    };
  };

  return TipHandler;
}(Handler);


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-popups@4.2.3@@ali/ve-popups/build/handler.js
// module id = 292
// module chunks = 0